import { NgModule } from '@angular/core';
import { BillingComponent } from './billing.component';
import { HeaderModule } from 'src/app/controls/header/header.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [BillingComponent],
    imports: [HeaderModule, CommonModule, FormsModule],
    exports: [BillingComponent],
    providers: [],
    bootstrap: [BillingComponent]
})
export class BillingModule { }